jQuery(document).ready(function($) {
    $('#ajax-login-form').submit(function(event) {
        event.preventDefault();
        var usernameInput = $('#username-lg');
        var passwordInput = $('#password-lg');
        var isFormValid = true;

        if (!usernameInput.val()  || !passwordInput.val()) {
            var errorMessage = '';
            // Перевіряємо заповненість полів
            if (!usernameInput.val() && !passwordInput.val()) { // Якщо обидва поля порожні
                var errorMessage = localized_texts.enter_fields;
                displayNotification(errorMessage, false, 3);
                removeErrorClass();
                usernameInput.addClass('error');
                passwordInput.addClass('error');
                isFormValid = false;
            } else if (!usernameInput.val()) { // Тільки username порожній
                var errorMessage = localized_texts.enter_username;
                displayNotification(errorMessage, false, 3);
                removeErrorClass();
                usernameInput.addClass('error');
                isFormValid = false;
            } else if (!passwordInput.val()) { // Тільки password порожній
                var errorMessage = localized_texts.enter_password;
                displayNotification(errorMessage, false, 3);
                removeErrorClass();
                passwordInput.addClass('error');
                isFormValid = false;
            }
        }

        if (isFormValid) {
            var formData = $(this).serialize();
            $.ajax({
                type: 'POST',
                url: ajax_login.ajax_url,
                data: formData + '&action=ajax_login_func',
                success: function (response) {
                    var jsonResponse = JSON.parse(response);
                    if (jsonResponse.success) {
                        removeErrorClass();
                        displayNotification(jsonResponse.message, jsonResponse.success, 2);
                        setTimeout(function() {
                            location.reload();
                        }, 2100); // Затримка 2.1 секунди
                    } else {
                        displayNotification(jsonResponse.message, jsonResponse.success, 3);
                        if (jsonResponse.field) {
                            removeErrorClass();
                            $('#' + jsonResponse.field).addClass('error');
                        }
                    }
                }
            });
        }
    });

    // Функція для відображення повідомлень
    function displayNotification(message, isSuccess, durationInSeconds = 15) {
        var notificationElement = $('.modal_notification');
        notificationElement.text(message).addClass('visible');
        if (!isSuccess) {
            notificationElement.addClass('error');
        } else {
            notificationElement.removeClass('error').addClass('success');
        }
        setTimeout(function() {
            notificationElement.removeClass('visible error success');
        }, durationInSeconds * 1000); // 15 секунд
    }

    function removeErrorClass() {
        var errorElement = document.querySelectorAll('.modal_form .error'); // Отримуємо всі елементи введення з класом помилки
        errorElement.forEach(function(input) { // Ітеруємося по кожному елементу
            input.classList.remove('error'); // Видаляємо клас помилки
        });
    }

});
